export enum OAUTH_TYPES {
  USER_GRANT = 'USER_GRANT',
  CLIENT_CREDENTIALS = 'CLIENT_CREDENTIALS',
  TWO_STEP = 'TWO_STEP',
  GRANT_OR_CREDENTIALS = 'GRANT_OR_CREDENTIALS',
}

export type GRANT_TYPE = 'client_credentials' | 'refresh_token' | 'authorization_code';
